<template>
  <v-snackbar
    v-model="display"
    :timeout="timeout"
    :color="color"
  >
    {{ $t(text) }}
    <template #actions="{ attrs }">
      <v-btn
        icon
        v-bind="attrs"
        @click="display = false"
      >
        <font-awesome-icon
          :icon="['fas', 'xmark']"
          size="xl"
        />
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snackbar',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'success',
    },
    timeout: {
      type: Number,
      default: 4000,
    },
  },
  computed: {
    display: {
      get() { return this.modelValue },
      set(display) { this.$emit('update:model-value', display); },
    },
  },
};
</script>
